export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/male.956e379.svg";